import React from "react";
import { useLocation } from "react-router-dom";
import { useCart } from "../context/CartContext";

const CartIcon = () => {
  const location = useLocation();
  const { cartItems } = useCart();

  const isAuthenticated = () => {
    return !!localStorage.getItem("tokenAcesso");
  };

  const totalQuantity = cartItems.reduce(
    (total, item) => total + item.quantity,
    0
  );

  return (
    <div className="flex-none">
      <div className="dropdown dropdown-end">
        <div tabIndex={0} role="button" className="pt-[0px]">
          <div className="indicator">
            {location.pathname === "/ar/cart" ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="32px"
                viewBox="0 -960 960 960"
                width="32px"
                fill="#3b82f6"
              >
                <path d="M289.4-98.1q-27.54 0-46.68-19.35-19.13-19.35-19.13-47t19.27-46.85q19.27-19.21 46.81-19.21 27.54 0 46.8 19.35 19.27 19.35 19.27 46.99 0 27.65-19.35 46.86T289.4-98.1Zm387.69 0q-27.54 0-46.67-19.35-19.14-19.35-19.14-47t19.27-46.85q19.27-19.21 46.81-19.21 27.54 0 46.81 19.35 19.26 19.35 19.26 46.99 0 27.65-19.34 46.86-19.35 19.21-47 19.21ZM210.36-790.41h555q24.53 0 37.09 21.09 12.57 21.09.78 42.86L678.55-500.6q-9.94 16.83-25.76 26.69-15.82 9.86-34.33 9.86H324l-52.26 96.25q-2.82 4.62-.06 10 2.76 5.39 8.53 5.39h463.22v50.25H284.67q-38.52 0-56.4-28.88-17.88-28.88-.27-61.37l61.95-112.36-149.33-314.97H65.28V-870h107.49l37.59 79.59Z" />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="32px"
                viewBox="0 -960 960 960"
                width="32px"
                fill="#000000"
              >
                <path d="M289.4-98.1q-27.54 0-46.68-19.35-19.13-19.35-19.13-47t19.27-46.85q19.27-19.21 46.81-19.21 27.54 0 46.8 19.35 19.27 19.35 19.27 46.99 0 27.65-19.35 46.86T289.4-98.1Zm387.69 0q-27.54 0-46.67-19.35-19.14-19.35-19.14-47t19.27-46.85q19.27-19.21 46.81-19.21 27.54 0 46.81 19.35 19.26 19.35 19.26 46.99 0 27.65-19.34 46.86-19.35 19.21-47 19.21ZM235.33-740.15l108.16 225.84h276.48q3.47 0 6.29-1.73t4.48-4.81l114.75-208.53q2.31-4.24.38-7.51-1.92-3.26-6.54-3.26h-504Zm-24.97-50.26h555q24.53 0 37.09 21.09 12.57 21.09.78 42.86L678.55-500.6q-9.94 16.83-25.76 26.69-15.82 9.86-34.33 9.86H324l-52.26 96.25q-2.82 4.62-.06 10 2.76 5.39 8.53 5.39h463.22v50.25H284.67q-38.52 0-56.4-28.88-17.88-28.88-.27-61.37l61.95-112.36-149.33-314.97H65.28V-870h107.49l37.59 79.59Zm133.13 276.1h283.79-283.79Z" />
              </svg>
            )}
            {!isAuthenticated ? (
              ""
            ) : (
              <span className="badge badge-sm indicator-item">
                {totalQuantity}
              </span>
            )}
          </div>
        </div>
        {/* {totalQuantity > 0 && (
          // <div
          //   tabIndex={0}
          //   className="mt-3 z-[1] card card-compact dropdown-content w-52 bg-base-100 shadow"
          // >
          //   <div className="card-body">
          //     <span className="font-bold text-lg">{totalQuantity}</span>
          //     <div className="card-actions">
          //       <button className="btn btn-primary btn-block">View cart</button>
          //     </div>
          //   </div>
          // </div>
        )} */}
      </div>
    </div>
  );
};

export default CartIcon;
